
import { Separator } from "@/components/ui/separator";
import { WordPressConnectForm } from "./WordPressConnectForm";

export const ConnectWordPressSection = () => {
  return (
    <div className="space-y-2">
      <h3 className="text-lg font-medium">3. Connect Your WordPress Account</h3>
      <p className="text-gray-500 text-sm">
        Enter your WordPress admin credentials below to establish a secure connection.
      </p>
      <WordPressConnectForm />
    </div>
  );
};
